(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
jQuery(document).on("click", '[data-toggle="lightbox"]', function(event) {
  event.preventDefault();
  $(this).ekkoLightbox();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommended"]) return;
  try {
    
function ProductRecommendations(container) { 
	var $container = (this.$container = $(container)); 
    var productId = $container.data('product-id'); 
    var limit = $container.data('limit'); 
    var productRecommendationsUrlAndContainerClass = '/recommendations/products?&section_id=product-recommended&limit=' + limit + '&product_id=' + productId; 	
    $container.parent().load(productRecommendationsUrlAndContainerClass); }; 
    document.addEventListener("DOMContentLoaded", function() { 
    ProductRecommendations($('#recommended-products')); 
});

  } catch(e) { console.error(e); }
})();
})();
